import type { SearchQuickFiltersResponse } from "@amzn/ads-blink-client";
import {
    QuickFilterAliasType,
    QuickFilterScopeType,
    type SearchQuickFiltersRequest,
} from "@amzn/ads-blink-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getBlinkApiClientV2 } from "../../../../api/blinkApi/blinkApi";
import { useAsyncErrorStatusNotification } from "../../../../hooks/notifications/useAsyncErrorStatusNotification";
import { authStore } from "../../../../store/auth";
import { getAdvertiserId } from "../../../../utils/permission.utils";

export const emptyResponse: SearchQuickFiltersResponse = {
    data: [],
};

export function SearchQuickFilterActionAsync(): [
    AsyncState<SearchQuickFiltersResponse>,
    UseAsyncActions<SearchQuickFiltersResponse>,
] {
    const [state, action] = useAsync(async () => {
        // In the future, if we want to make this action more versatile, we should pass in the
        // references, but for now there is no use case outside this hard-coded one
        const request: SearchQuickFiltersRequest = {
            references: [
                {
                    scopeType: QuickFilterScopeType.SFID,
                    scopeValue: getAdvertiserId(),
                    aliasType: QuickFilterAliasType.USER,
                    aliasValue: authStore.getState().username,
                },
                {
                    scopeType: QuickFilterScopeType.GLOBAL,
                    scopeValue: "GLOBAL",
                    aliasType: QuickFilterAliasType.USER,
                    aliasValue: authStore.getState().username,
                },
            ],
        };

        const response = await (
            await getBlinkApiClientV2()
        ).searchQuickFilters(request);

        return {
            ...emptyResponse,
            ...response,
        } as SearchQuickFiltersResponse;
    }, emptyResponse);

    // Alert the user of any errors we run into
    useAsyncErrorStatusNotification(state);

    return [state, action];
}
